import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';

function PlayerProfile() {
    const { playerId } = useParams();
    const [player, setPlayer] = useState({});
    const [stats, setStats] = useState([]);
    const [error, setError] = useState(null);

    useEffect(() => {
        fetch(`${process.env.REACT_APP_API_URL}/stats/player/${playerId}/`) // Updated API URL
            .then((response) => {
                if (!response.ok) {
                    throw new Error(`HTTP error! Status: ${response.status}`);
                }
                return response.json();
            })
            .then((data) => {
                setPlayer(data.player || {});
                setStats(data.stats || []);
            })
            .catch((err) => setError(err.message));
    }, [playerId]);

    if (error) {
        return <div>Error: {error}</div>;
    }

    return (
        <div>
            <h1>{player.name} - Profile</h1>
            <h2>Stats</h2>
            <ul>
                {stats.map((stat, index) => (
                    <li key={index}>
                        Game: {stat.game__opposing_team__name}, KAO: {stat.kao}, KAPasses: {stat.kapasses}, KAPct: {stat.kapct}%, Points: {stat.points}
                    </li>
                ))}
            </ul>
        </div>
    );
}

export default PlayerProfile;
